import React from 'react';
import { Typography } from '@guildeducationinc/recess';
import NotificationsIcon from '@guildeducationinc/recess/icons/NotificationsIcon';
import { useDecision } from '@optimizely/react-sdk';
import { trackEvent } from '@src/services/analytics';
import { snakeCase } from 'lodash';
import styles from './Banner.module.scss';

export const Banner = (): React.ReactElement => {
	const [decision] = useDecision('catalog_banner');
	const variables = decision.variables;
	const isEnabled = decision.enabled;

	const bannerMessage = variables?.SD_BANNER_MESSAGE;
	const linkText = (variables?.SD_BANNER_LINK_TEXT as string) || '';
	const link = (variables?.SD_BANNER_URL as string) || '';

	if (!isEnabled || (isEnabled && !bannerMessage)) {
		return null;
	}

	return (
		<div className={styles.banner} role='banner'>
			<NotificationsIcon className={styles.bannerIcon} size={24} />
			<Typography className={styles.bannerMessage} variant='body1'>
				{bannerMessage}{' '}
				{link && linkText && (
					<a
						className={styles.bannerUrl}
						href={link}
						onClick={() => {
							trackEvent('Clickable', {
								tag: 'catalog_banner',
								text: snakeCase(linkText),
								type: 'link',
							});
						}}
						rel='noopener, noreferrer'
						target='_blank'
					>
						{linkText}
					</a>
				)}
			</Typography>
		</div>
	);
};
